import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { bookingUrl } from '../data/content';
const reveal = {
  initial: {
    opacity: 0,
    y: 16
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-80px'
  },
  whileHover: {
    y: -4
  }
};
const cardBase = 'flex h-full flex-col rounded-4xl border border-slate-200 bg-pearl-50 p-7 dark:border-slate-800 dark:bg-slate-800';
const cardFeatured = 'flex h-full flex-col rounded-4xl border border-slate-900 bg-gradient-to-b from-butter-50 to-white p-7 ring-1 ring-slate-900 dark:border-butter-300 dark:from-slate-800 dark:to-slate-900 dark:ring-butter-300';
const featureRow = 'flex gap-2.5 text-sm text-slate-700 dark:text-slate-200';
const checkClass = 'mt-0.5 h-4 w-4 flex-none text-butter-600 dark:text-butter-300';
const buttonQuiet = 'mt-8 inline-flex items-center justify-center rounded-full border border-slate-300 px-6 py-3.5 text-sm font-semibold text-slate-800 transition-colors hover:border-slate-400 dark:border-slate-600 dark:text-pearl-100';
const buttonSolid = 'mt-8 inline-flex items-center justify-center rounded-full bg-slate-900 px-6 py-3.5 text-sm font-semibold text-pearl-50 transition-colors hover:bg-slate-700 dark:bg-butter-300 dark:text-slate-900 dark:hover:bg-butter-200';
export function Pricing() {
  return <section id="pricing" className="bg-white py-16 dark:bg-slate-900 sm:py-20" data-id="element-179" data-mp="eoz8tqp3slul">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-180" data-mp="3dasavd29jfq9">
        <div className="max-w-2xl" data-id="element-181" data-mp="3i7906al7804x">
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-plum-500 dark:text-plum-300" data-id="element-182" data-mp="3i8bp4cyynsi7">
            Pricing
          </p>
          <h2 className="mt-3 font-display text-3xl font-semibold tracking-tight text-slate-900 dark:text-pearl-50 sm:text-4xl" data-id="element-183" data-mp="3rxlirx9gdj8f">
            Three ways to work together
          </h2>
          <p className="mt-4 text-lg text-slate-600 dark:text-slate-300" data-id="element-184" data-mp="2zhkjnmi3gm93">
            Final pricing is shared on the free consult call and in writing before you commit. Pause or cancel anytime, and unused sessions are refunded. 
          </p>
        </div>

        <ul className="mt-10 grid items-start gap-6 lg:grid-cols-3" data-id="element-185" data-mp="2mh0714ycqwq1">
          {/* Package 1 */}
          <motion.li {...reveal} transition={{
          duration: 0.45,
          ease: [0.22, 1, 0.36, 1]
        }} className={cardBase} data-id="element-186" data-mp="315cz3qubjvf9">
            <div className="flex items-center justify-between gap-3" data-id="element-187" data-mp="28i0li664yxy3">
              <h3 className="font-display text-xl font-semibold text-slate-900 dark:text-pearl-50" data-id="element-188" data-mp="28i8zy2hwqbbe">
                Kickstart
              </h3>
            </div>

            <p className="mt-5 flex items-baseline gap-2" data-id="element-189" data-mp="2iggbg5tfg160">
              <span className="font-display text-4xl font-semibold text-slate-900 dark:text-pearl-50" data-id="element-190" data-mp="2idtx9nc16net">
                $$
              </span>
              <span className="text-sm text-slate-500 dark:text-slate-400" data-id="element-191" data-mp="3tuae9l38hc3s">
                one 60-min session
              </span>
            </p>

            <p className="mt-4 leading-relaxed text-slate-600 dark:text-slate-300" data-id="element-192" data-mp="3oylbl8vx3f39">
              A single deep-dive to iron out one main goal. Best fit for someone who has an upcoming interview, presentation, or has general coaching questions.
            </p>

            <ul className="mt-6 flex-1 space-y-2.5" data-id="element-193" data-mp="3ngel3ob8iu2c">
              <li className={featureRow} data-id="element-194" data-mp="3rgonys3qd4cz">
                <CheckIcon className={checkClass} aria-hidden="true" data-id="element-195" data-mp="3rhgaldfcnrr4" />
                <span data-id="element-196" data-mp="j0d6j3bskqho">60-minute 1:1 coaching session</span>
              </li>
              <li className={featureRow} data-id="element-197" data-mp="nzyg07ol8h8n">
                <CheckIcon className={checkClass} aria-hidden="true" data-id="element-198" data-mp="nywt95y7m6b3" />
                <span data-id="element-199" data-mp="a8tfl3debkx9">Written action plan within 48 hours</span>
              </li>
              <li className={featureRow} data-id="element-200" data-mp="ea5578w9s65g">
                <CheckIcon className={checkClass} aria-hidden="true" data-id="element-201" data-mp="e93ig75w5v7w" />
                <span data-id="element-202" data-mp="11zzg3kx13kn2">2 weeks of follow-up support within business hours</span>
              </li>
              <li className={featureRow} data-id="element-203" data-mp="16q7ilioaeb0v">
                <CheckIcon className={checkClass} aria-hidden="true" data-id="element-204" data-mp="16r928bjdc5u7" />
                <span data-id="element-205" data-mp="3f7sci0y0udwd">10% off Launch package if upgraded</span>
              </li>
            </ul>

            <a href={bookingUrl} target="_blank" rel="noopener noreferrer" className={buttonQuiet} data-id="element-206" data-mp="3a85yvqea6vn1">
              Start with Kickstart
            </a>
          </motion.li>

          {/* Package 2 — featured */}
          <motion.li {...reveal} transition={{
          duration: 0.45,
          delay: 0.07,
          ease: [0.22, 1, 0.36, 1]
        }} className={cardFeatured} data-id="element-207" data-mp="318somvic2319">
            <div className="flex items-center justify-between gap-3" data-id="element-208" data-mp="3sz6vw8vuch3y">
              <h3 className="font-display text-xl font-semibold text-slate-900 dark:text-pearl-50" data-id="element-209" data-mp="3t102xpad93ch">
                Launch
              </h3>
              <span className="rounded-full bg-gradient-to-r from-butter-300 to-butter-200 px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-butter-700 dark:from-butter-400 dark:to-butter-300 dark:text-slate-900" data-id="element-210" data-mp="3k74uo8dy6wsm">
                CLIENT FAVORITE
              </span>
            </div>

            <p className="mt-5 flex items-baseline gap-2" data-id="element-211" data-mp="1yfolk10jnmh9">
              <span className="font-display text-4xl font-semibold text-slate-900 dark:text-pearl-50" data-id="element-212" data-mp="1yhhqnbvidyn5">
                $$
              </span>
              <span className="text-sm text-slate-500 dark:text-slate-400" data-id="element-213" data-mp="27fjx46y0hjht">
                2 sessions over 1 month
              </span>
            </p>

            <p className="mt-4 leading-relaxed text-slate-600 dark:text-slate-300" data-id="element-214" data-mp="2cctnbot85z6p">
              Our core program that is time efficient and effective. Best for someone looking to receive support on 2-3 goals.
            </p>

            <ul className="mt-6 flex-1 space-y-2.5" data-id="element-215" data-mp="2r42j6fnq0gsa">
              <li className={featureRow} data-id="element-216" data-mp="2r4lzjrxq2x47">
                <CheckIcon className={checkClass} aria-hidden="true" data-id="element-217" data-mp="2v55vwtah1wpa" />
                <span data-id="element-218" data-mp="2v7if19ryud3x">Two, 60-minute 1:1 coaching sessions</span>
              </li>
              <li className={featureRow} data-id="element-219" data-mp="306brqzzfi031">
                <CheckIcon className={checkClass} aria-hidden="true" data-id="element-220" data-mp="353bv334w8oqg" />
                <span data-id="element-221" data-mp="351h7ti65gkj7">Written action plan within 24 hours of each session</span>
              </li>
              
              <li className={featureRow} data-id="element-222" data-mp="10298dpahwz8e">
                <CheckIcon className={checkClass} aria-hidden="true" data-id="element-223" data-mp="103ainrjothp2" />
                <span data-id="element-224" data-mp="1eqvoht7y5v0o">Async support via Text or Email outside of business hours if needed</span>
              </li>
              
              <li className={featureRow} data-id="element-225" data-mp="19zdtdlsluonm">
                <CheckIcon className={checkClass} aria-hidden="true" data-id="element-226" data-mp="19ym0iiqe7511" />
                <span data-id="element-227" data-mp="1nq8ycmzzgllx">10% off Expert package if upgraded</span>
              </li>
            </ul>

            <a href={bookingUrl} target="_blank" rel="noopener noreferrer" className={buttonSolid} data-id="element-228" data-mp="1jpp01g3obby7">
              Start with Launch
            </a>
          </motion.li>

          {/* Package 3 */}
          <motion.li {...reveal} transition={{
          duration: 0.45,
          delay: 0.14,
          ease: [0.22, 1, 0.36, 1]
        }} className={cardBase} data-id="element-229" data-mp="1srg5qky7ris2">
            <div className="flex items-center justify-between gap-3" data-id="element-230" data-mp="3uitbfc809up6">
              <h3 className="font-display text-xl font-semibold text-slate-900 dark:text-pearl-50" data-id="element-231" data-mp="2a08ydkychdci">
                Expert
              </h3>
            </div>

            <p className="mt-5 flex items-baseline gap-2" data-id="element-232" data-mp="2eyslhooocv6g">
              <span className="font-display text-4xl font-semibold text-slate-900 dark:text-pearl-50" data-id="element-233" data-mp="20az5i2vofqnc">
                $$$
              </span>
              <span className="text-sm text-slate-500 dark:text-slate-400" data-id="element-234" data-mp="257xz8kbfhvl0">
                4+ sessions over 3 months
              </span>
            </p>

            <p className="mt-4 leading-relaxed text-slate-600 dark:text-slate-300" data-id="element-235" data-mp="1w9dlzyon0e46">
              For a longer runway — internship season, senior year, or a first-job pivot with real
              support.
            </p>

            <ul className="mt-6 flex-1 space-y-2.5" data-id="element-236" data-mp="1mbpox23k6uiu">
              <li className={featureRow} data-id="element-237" data-mp="3bpl34qr9avac">
                <CheckIcon className={checkClass} aria-hidden="true" data-id="element-238" data-mp="3bqnuezshqzqs" />
                <span data-id="element-239" data-mp="3gofnhx4vgrwk">Everything in Launch   </span>
              </li>
              
              <li className={featureRow} data-id="element-240" data-mp="24fcccpgsq8u9">
                <CheckIcon className={checkClass} aria-hidden="true" data-id="element-241" data-mp="24easpwlpse0x" />
                <span data-id="element-242" data-mp="1zfpo7kzfj86o">Certified LinkedIn badge</span>
              </li>
              <li className={featureRow} data-id="element-243" data-mp="1zilnbcn0k2wp">
                <CheckIcon className={checkClass} aria-hidden="true" data-id="element-244" data-mp="1uor56dn23vzq" />
                <span data-id="element-245" data-mp="1pqfz8dzvu5ms">Peer support group access via WhatsApp</span>
              </li>
              <li className={featureRow} data-id="element-246" data-mp="1polkjhf7f9r5">
                <CheckIcon className={checkClass} aria-hidden="true" data-id="element-247" data-mp="1krlcj0ysnwxe" />
                <span data-id="element-248" data-mp="1gpzuz2bbeugv">Bonus free friend session</span>
              </li>
            </ul>

            <a href={bookingUrl} target="_blank" rel="noopener noreferrer" className={buttonQuiet} data-id="element-249" data-mp="1bqn9akw6jtfv">
              Start with Expert
            </a>
          </motion.li>
        </ul>
      </div>
    </section>;
}